import React, { useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { Container, Navbar, Offcanvas } from "react-bootstrap";
import Cookies from "js-cookie"
function AdminMainTemplate() {
  const [showSidebar, setShowSidebar] = useState(false);
  const [activeTab, setActiveTab] = useState("courses");
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    setShowSidebar(false); // Hide sidebar on click
  };
  const [selectedCourse, setSelectedCourse] = useState("product");

  const handleCourseClick = (course) => {
    setSelectedCourse(course);
  };
  const logoutHandle = () => {
   Cookies.remove("auth");
   window.location.reload();
  }
  return (
    <div className=" container-fluid ">
      <Navbar
        variant="dark"
        expand="md"
        className="d-md-none bg_darkblue w-100"
      >
        <Container className="">
          <Navbar.Brand href="#">
            <Link to="/products">
              <img
                className="rounded-5"
                width={90}
                src={`https://api-dev.tejar.ai/assets/image/logo.png`}
                alt="logo"
              />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="offcanvas-nav"
            onClick={() => setShowSidebar(!showSidebar)}
          />
          <Navbar.Offcanvas
            className="bg_darkblue"
            id="offcanvas-nav"
            aria-labelledby="offcanvas-nav-label"
            placement="start"
            show={showSidebar}
            onHide={() => setShowSidebar(false)}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title className="" id="offcanvas-nav-label">
                <img
                  className="  rounded-5"
                  width={90}
                  src={`https://api-dev.tejar.ai/assets/image/logo.png`}
                  alt="logo"
                />
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="d-flex flex-column justify-content-between">
              <ul className="nav flex-column">
                <Link to={"/products"} className={`nav-item py-1`}>
                  <li
                    className={`nav-item py-1 px-3 mt-3 ${activeTab === "courses" ? "custom_bg" : ""
                      }`}
                    onClick={() => handleTabClick("courses")}
                  >
                    <span className="text-block ff_heebo fw-medium cursor_pointer">
                      Product
                    </span>
                  </li>
                </Link>
                <Link to={"/settings"} className={`nav-item py-1`}>
                  <li
                    className={`nav-item py-1 px-3 mt-3 ${activeTab === "blogs" ? "custom_bg" : ""
                      }`}
                    onClick={() => handleTabClick("blogs")}
                  >
                    <span className="text-block ff_heebo fw-medium cursor_pointer">
                      Settings
                    </span>
                  </li>
                </Link>
              </ul>
              <button onClick={logoutHandle}
                className="d-flex mt-3 ps-4 px-3 gap-3 align-items-center bg-transparent border-0"
              >
                <svg
                  className=" cursor-pointer"
                  width={20}
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg"
                  id="fi_15604005"
                >
                  <g id="Icon">
                    <path d="m20 23v4.5a2.5 2.5 0 0 1 -2.5 2.5h-13a2.5 2.5 0 0 1 -2.5-2.5v-23a2.5 2.5 0 0 1 2.5-2.5h13a2.5 2.5 0 0 1 2.5 2.5v4.5a1 1 0 0 1 -2 0v-4.5a.5.5 0 0 0 -.5-.5h-13a.5.5 0 0 0 -.5.5v23a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-4.5a1 1 0 0 1 2 0zm9.71-7.71-4.95-4.95a1 1 0 0 0 -1.42 1.42l3.25 3.24h-17.07a1 1 0 0 0 0 2h17.07l-3.25 3.24a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4.95-4.95a1 1 0 0 0 0-1.42z"></path>
                  </g>
                </svg>

                <span
                  className=" cursor_pointer ff_heebo  fw-semibold py-1 text-secondary border-0 "
                >
                  Logout
                </span>
              </button>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
      <div>
        <div className="row">
          <div
            className="col-xl-2  col-md-3 d-none d-md-block py-4 px-0 bg-white min-vh-100 border-end border-2"
            style={{ height: "100vh", overflow: "hidden" }}
          >
            <div className="d-flex flex-column justify-content-between h-100">
              <div>
                <span className="px-4" href="#">
                  <Link to="/products">
                    <img
                      className="rounded-5"
                      width={90}
                      src={`https://api-dev.tejar.ai/assets/image/logo.png`}
                      alt="logo"
                    />
                  </Link>
                </span>
                <div className="border mt-4"></div>
                <ul className="nav flex-column mt-2 px-3">
                  <button
                    // className={`nav-item py-1 px-3 d-flex mt-3 px-3 gap-3 align-items-center ${
                    //   activeTab === "courses" ? "text-black" : "active"
                    // }`}
                    onClick={() => handleCourseClick("product")}
                    className={
                      selectedCourse === "product"
                        ? "active py-1 px-3 d-flex mt-3 px-3 gap-3 align-items-center bg-transparent border-0"
                        : "nav-item py-1 px-3 d-flex mt-3 px-3 gap-3 align-items-center bg-transparent border-0"
                    }

                  // className="d-flex mt-3 px-3 gap-3 align-items-center"
                  >
                    <Link
                      className="d-flex gap-3 align-items-center"
                      to={"/products"}
                    >
                      <svg
                        className="cursor-pointer"
                        id="fi_2652218"
                        enable-background="new 0 0 96 96"
                        height="20"
                        viewBox="0 0 96 96"
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          id="Product_Package"
                          d="m90.895 25.211-42-21c-.563-.281-1.227-.281-1.789 0l-42 21c-.678.339-1.106 1.031-1.106 1.789v42c0 .758.428 1.45 1.105 1.789l42 21c.282.141.588.211.895.211s.613-.07.895-.211l42-21c.677-.339 1.105-1.031 1.105-1.789v-42c0-.758-.428-1.45-1.105-1.789zm-42.895-16.975 37.528 18.764-8.028 4.014-37.527-18.764zm13.5 30.778-37.528-18.764 11.528-5.764 37.528 18.764zm1.5 3.722 12-6v14.877l-3.838-2.741c-.435-.311-.979-.434-1.506-.343-.527.093-.996.392-1.301.832l-5.355 7.737zm-43.5-20.25 37.527 18.764-9.027 4.514-37.528-18.764zm-11.5 7.75 38 19v37.527l-38-19zm42 56.528v-37.528l9-4.5v18.764c0 .875.568 1.648 1.403 1.909.198.062.398.091.597.091.644 0 1.264-.312 1.645-.861l7.845-11.331 5.349 3.82c.61.435 1.412.494 2.077.15.665-.342 1.084-1.029 1.084-1.778v-20.764l9-4.5v37.527z"
                        ></path>
                      </svg>

                      <span className=" ff_heebo fw-medium cursor_pointer">
                        Products
                      </span>
                    </Link>
                  </button>
                  <button
                    onClick={() => handleCourseClick("blog")}
                    className={
                      selectedCourse === "blog"
                        ? "active py-1 px-3 d-flex mt-3 px-3 gap-3 align-items-center bg-transparent border-0"
                        : "nav-item py-1 px-3 d-flex mt-3 px-3 gap-3 align-items-center bg-transparent border-0"
                    }

                  >
                    <Link
                      className="d-flex gap-3 align-items-center"
                      to={"/settings"}
                    >
                      <svg
                        className="cursor-pointer"
                        id="fi_2099058"
                        enable-background="new 0 0 512 512"
                        height="20"
                        viewBox="0 0 512 512"
                        width="20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="m272.066 512h-32.133c-25.989 0-47.134-21.144-47.134-47.133v-10.871c-11.049-3.53-21.784-7.986-32.097-13.323l-7.704 7.704c-18.659 18.682-48.548 18.134-66.665-.007l-22.711-22.71c-18.149-18.129-18.671-48.008.006-66.665l7.698-7.698c-5.337-10.313-9.792-21.046-13.323-32.097h-10.87c-25.988 0-47.133-21.144-47.133-47.133v-32.134c0-25.989 21.145-47.133 47.134-47.133h10.87c3.531-11.05 7.986-21.784 13.323-32.097l-7.704-7.703c-18.666-18.646-18.151-48.528.006-66.665l22.713-22.712c18.159-18.184 48.041-18.638 66.664.006l7.697 7.697c10.313-5.336 21.048-9.792 32.097-13.323v-10.87c0-25.989 21.144-47.133 47.134-47.133h32.133c25.989 0 47.133 21.144 47.133 47.133v10.871c11.049 3.53 21.784 7.986 32.097 13.323l7.704-7.704c18.659-18.682 48.548-18.134 66.665.007l22.711 22.71c18.149 18.129 18.671 48.008-.006 66.665l-7.698 7.698c5.337 10.313 9.792 21.046 13.323 32.097h10.87c25.989 0 47.134 21.144 47.134 47.133v32.134c0 25.989-21.145 47.133-47.134 47.133h-10.87c-3.531 11.05-7.986 21.784-13.323 32.097l7.704 7.704c18.666 18.646 18.151 48.528-.006 66.665l-22.713 22.712c-18.159 18.184-48.041 18.638-66.664-.006l-7.697-7.697c-10.313 5.336-21.048 9.792-32.097 13.323v10.871c0 25.987-21.144 47.131-47.134 47.131zm-106.349-102.83c14.327 8.473 29.747 14.874 45.831 19.025 6.624 1.709 11.252 7.683 11.252 14.524v22.148c0 9.447 7.687 17.133 17.134 17.133h32.133c9.447 0 17.134-7.686 17.134-17.133v-22.148c0-6.841 4.628-12.815 11.252-14.524 16.084-4.151 31.504-10.552 45.831-19.025 5.895-3.486 13.4-2.538 18.243 2.305l15.688 15.689c6.764 6.772 17.626 6.615 24.224.007l22.727-22.726c6.582-6.574 6.802-17.438.006-24.225l-15.695-15.695c-4.842-4.842-5.79-12.348-2.305-18.242 8.473-14.326 14.873-29.746 19.024-45.831 1.71-6.624 7.684-11.251 14.524-11.251h22.147c9.447 0 17.134-7.686 17.134-17.133v-32.134c0-9.447-7.687-17.133-17.134-17.133h-22.147c-6.841 0-12.814-4.628-14.524-11.251-4.151-16.085-10.552-31.505-19.024-45.831-3.485-5.894-2.537-13.4 2.305-18.242l15.689-15.689c6.782-6.774 6.605-17.634.006-24.225l-22.725-22.725c-6.587-6.596-17.451-6.789-24.225-.006l-15.694 15.695c-4.842 4.843-12.35 5.791-18.243 2.305-14.327-8.473-29.747-14.874-45.831-19.025-6.624-1.709-11.252-7.683-11.252-14.524v-22.15c0-9.447-7.687-17.133-17.134-17.133h-32.133c-9.447 0-17.134 7.686-17.134 17.133v22.148c0 6.841-4.628 12.815-11.252 14.524-16.084 4.151-31.504 10.552-45.831 19.025-5.896 3.485-13.401 2.537-18.243-2.305l-15.688-15.689c-6.764-6.772-17.627-6.615-24.224-.007l-22.727 22.726c-6.582 6.574-6.802 17.437-.006 24.225l15.695 15.695c4.842 4.842 5.79 12.348 2.305 18.242-8.473 14.326-14.873 29.746-19.024 45.831-1.71 6.624-7.684 11.251-14.524 11.251h-22.148c-9.447.001-17.134 7.687-17.134 17.134v32.134c0 9.447 7.687 17.133 17.134 17.133h22.147c6.841 0 12.814 4.628 14.524 11.251 4.151 16.085 10.552 31.505 19.024 45.831 3.485 5.894 2.537 13.4-2.305 18.242l-15.689 15.689c-6.782 6.774-6.605 17.634-.006 24.225l22.725 22.725c6.587 6.596 17.451 6.789 24.225.006l15.694-15.695c3.568-3.567 10.991-6.594 18.244-2.304z"></path>
                        <path d="m256 367.4c-61.427 0-111.4-49.974-111.4-111.4s49.973-111.4 111.4-111.4 111.4 49.974 111.4 111.4-49.973 111.4-111.4 111.4zm0-192.8c-44.885 0-81.4 36.516-81.4 81.4s36.516 81.4 81.4 81.4 81.4-36.516 81.4-81.4-36.515-81.4-81.4-81.4z"></path>
                      </svg>

                      <span className="text-secondary ff_heebo fw-medium cursor_pointer">
                        Settings
                      </span>
                    </Link>
                  </button>
                </ul>
              </div>

              <button onClick={logoutHandle}
                className="d-flex mt-3 ps-4 px-3 gap-3 align-items-center bg-transparent border-0"
              >
                <svg
                  className=" cursor-pointer"
                  width={20}
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg"
                  id="fi_15604005"
                >
                  <g id="Icon">
                    <path d="m20 23v4.5a2.5 2.5 0 0 1 -2.5 2.5h-13a2.5 2.5 0 0 1 -2.5-2.5v-23a2.5 2.5 0 0 1 2.5-2.5h13a2.5 2.5 0 0 1 2.5 2.5v4.5a1 1 0 0 1 -2 0v-4.5a.5.5 0 0 0 -.5-.5h-13a.5.5 0 0 0 -.5.5v23a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-4.5a1 1 0 0 1 2 0zm9.71-7.71-4.95-4.95a1 1 0 0 0 -1.42 1.42l3.25 3.24h-17.07a1 1 0 0 0 0 2h17.07l-3.25 3.24a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4.95-4.95a1 1 0 0 0 0-1.42z"></path>
                  </g>
                </svg>

                <span
                  className=" cursor_pointer ff_heebo  fw-semibold py-1 text-secondary border-0 "
                >
                  Logout
                </span>
              </button>

            </div>
          </div>
          <div
            className="col-xl-10 overflow-y-auto p-0 custom_bg col-md-9 min-vh-100"
            style={{ height: "100vh"}}
          >
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminMainTemplate;
